import React from 'react';
import usePDPExtraCushion from 'data-hooks/usePDPExtraCushion';
import PDPExtraOptionSelectorUI from './PDPExtraOptionSelectorUI';

const PDPExtraOptionSelector = () => {
  const {
    loading,
    error,
    data: { isAdded, priceObj },
    actions: { onAdd, onRemove },
  } = usePDPExtraCushion();

  if (error) return null;

  return (
    <PDPExtraOptionSelectorUI
      loading={loading}
      priceObj={priceObj}
      isAdded={isAdded}
      onAdd={onAdd}
      onRemove={onRemove}
    />
  );
};

export default PDPExtraOptionSelector;
